module.exports = __webpack_public_path__ + "static/media/myRewards-Logo.0ea1710e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/myRewards-Logo.jpg
// module id = 5945
// module chunks = 1